import $ from 'jquery';

function placeWasThisHelpful(wasThisHelpfulContent) {
  // for some reason need to get the spacer again here, or offset is 0
  const offset = $('#was-this-helpful-spacer').offset();
  const top = `${Math.round(offset.top)}px`;
  const left = `${Math.round(offset.left)}px`;
  wasThisHelpfulContent.css({
    top,
    left
  });
}

function addWasThisHelpfulHeightObserver(wasThisHelpfulContent) {
  if (!window.ResizeObserver) return;

  let contentHeight = wasThisHelpfulContent.outerHeight();
  // eslint-disable-next-line no-undef
  const resizeObserver = new ResizeObserver(() => {
    const currentHeight = wasThisHelpfulContent.outerHeight();
    if (currentHeight === contentHeight) return;
    contentHeight = currentHeight;
    // have to re-get the spacer each time or the height change doesn't work
    $('#was-this-helpful-spacer').css({
      height: `${contentHeight}px`
    });
  });
  resizeObserver.observe(wasThisHelpfulContent[0]);
}

function init() {
  const wasThisHelpfulSpacer = $('#was-this-helpful-spacer');
  const wasThisHelpfulContent = $('.helpful-block-content');
  if (!wasThisHelpfulSpacer.length || !wasThisHelpfulContent.length) {
    return;
  }

  $(document).ready(() => {
    setTimeout(() => {
      placeWasThisHelpful(wasThisHelpfulContent);
      addWasThisHelpfulHeightObserver(wasThisHelpfulContent);
    }, 2000);
  });

  $(window).resize(() => {
    placeWasThisHelpful(wasThisHelpfulContent);
  });
}

export default {
  init
};
